export const mepRef15Options = [
  'me',
  'other-adults',
  'babies-children-young-people',
  'people-who-need-assistance',
  'pets',
  'livestock-and-other-animals',
] as const;

export const mepRef15OptionsLabels: Record<(typeof mepRef15Options)[number], string> = {
  me: 'Myself',
  'other-adults': 'Other adults, including visitors',
  'babies-children-young-people': 'Babies, children and young people',
  'people-who-need-assistance': 'People who need assistance',
  pets: 'Pets',
  'livestock-and-other-animals': 'Livestock and other animals',
};

export const mepRef15OptionsIcons: Record<(typeof mepRef15Options)[number], string> = {
  me: 'man',
  'other-adults': 'hail',
  'babies-children-young-people': 'stroller',
  'people-who-need-assistance': 'elderly_women',
  pets: 'pets',
  'livestock-and-other-animals': 'agriculture',
};
